import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentAdicionarImposto from "./DialogContentAdicionarImposto";

export default function AdicionarImpostos({
  value,
  onChange,
  required = false,
  error = false,
  inputSize = "medium"
}: SelectSimpleApiQueryProps) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = (() => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value.filter((item) => item.aplica).map((item) => item.nome).join(", ");
    } else {
      return ``;
    }
  })();

  return (
    <>
      <TextField
        {...{ required, error }}
        label={`Alíquota`}
        size={inputSize}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true}
        }}
        value={inputLabel}
        helperText={error ? "Campo obrigatório" : ""}
      />

      {openModal && (
        <Dialog fullWidth maxWidth="sm" open={openModal} onClose={handleClose}>
          <DialogContentAdicionarImposto
            value={value}
            handleSalvar={(novosValores) => {
              onChange(novosValores);
              handleClose();
            }}
          />
        </Dialog>
      )}
    </>
  );
}

interface SelectSimpleApiQueryProps {
  value: TAdicionarImposto[];
  onChange: (arg: TAdicionarImposto[]) => void;
  required?: boolean;
  error?: boolean;
  inputSize?: "small" | "medium";
}

export type TAdicionarImposto = {
  aplica: boolean;
  valor: string;
  nome: string;
  incluso_preco: boolean;
  direito_credito: boolean;
}
